import { isObject } from 'src/utils/objects';
export const isNotEmpty = (value) => value.trim() !== '';
export const isUnique = (value, list) => !list.includes(value);
export const isDayjs = (value) => (value?.isValid ? value.isValid() : false);
export const isObjectOrArray = (obj) => isObject(obj) || Array.isArray(obj);
